(function () {
  var replacements = [
    ["Kenogen Men’s Shampoo – Melatonin Formula for Thinning-Looking Hair", "Kenogen Men shampoo · For hair loss and thinning hair."],
    ["Kenogen Women’s Shampoo – Melatonin Formula for Thinning-Looking Hair", "Kenogen Women shampoo · For hair loss and thinning hair."]
  ];
  function revised(value) {
    replacements.forEach(function (pair) { value = value.split(pair[0]).join(pair[1]); });
    return value;
  }
  function update() {
    var links = document.querySelectorAll('a[href*="/products/kenogen-melatonin-shampoo-for-"]');
    links.forEach(function (link) {
      if (link.closest('.jdgm-widget')) return;
      var walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var value = revised(node.nodeValue);
        if (value !== node.nodeValue) node.nodeValue = value;
      }
      if (link.hasAttribute('aria-label')) {
        var label = link.getAttribute('aria-label');
        var next = revised(label);
        if (next !== label) link.setAttribute('aria-label', next);
      }
    });
  }
  var pending = false;
  var observer = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; update(); });
  });
  update();
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
})();
